/** @jsxImportSource theme-ui */
import { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: `calc(100vh - 4rem)`,
  bg: 'neutral/100', // Neutral/neutral.100 from Figma
};

export const contentCardStyles: ThemeUIStyleObject = {
  bg: 'neutral/000', // Neutral/neutral.000 from Figma
  border: '1px solid',
  borderColor: 'neutral/200', // Light border as per Figma
  boxShadow: 'none', // No shadow in Figma design
  borderRadius: '0.5rem', // 8px as per Figma
  width: 'auto',
  padding: ['3rem'],
};

export const contentStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem', // 24px gap between text and button sections
  textAlign: 'center',
};

export const textSectionStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.5rem', // 8px gap between title and subtitle
  width: '100%',
};
